/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Footer_Badges_Code_LabelInputs */

const en_admin_footer_badges_code_label = /** @type {(inputs: Admin_Footer_Badges_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Badge embed code`)
};

/**
* | output |
* | --- |
* | "Badge embed code" |
*
* @param {Admin_Footer_Badges_Code_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_footer_badges_code_label = /** @type {((inputs?: Admin_Footer_Badges_Code_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Footer_Badges_Code_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_footer_badges_code_label(inputs)
});
export { admin_footer_badges_code_label as "admin.footer_badges.code_label" }